export default {
  FETCH_COMMUNITY_POSTS: 'FETCH_COMMUNITY_POSTS',
  FETCH_COMMUNITY_POSTS_SUCCESS: 'FETCH_COMMUNITY_POSTS_SUCCESS',
  FETCH_COMMUNITY_POSTS_FAILURE: 'FETCH_COMMUNITY_POSTS_FAILURE',

  FETCH_COMMUNITY_WIDGETS: 'FETCH_COMMUNITY_WIDGETS',
  FETCH_COMMUNITY_WIDGETS_SUCCESS: 'FETCH_COMMUNITY_WIDGETS_SUCCESS',
  FETCH_COMMUNITY_WIDGETS_FAILURE: 'FETCH_COMMUNITY_WIDGETS_FAILURE',
};
